import { Form, Button, Row, Col } from 'react-bootstrap';
import { Search, X } from 'lucide-react';
import type { AlertFilter } from '../models/types';

export type MatchTypeFilter = 'matched' | 'machineUnmatched' | 'humanUnmatched';

interface CompetitorProductFiltersProps {
  readonly searchQuery: string;
  readonly onSearchQueryChange: (query: string) => void;
  readonly matchType: MatchTypeFilter;
  readonly onMatchTypeChange: (matchType: MatchTypeFilter) => void;
  readonly alertFilter: AlertFilter;
  readonly onAlertFilterChange: (alertFilter: AlertFilter) => void;
  readonly onSearch: () => void;
  readonly onClear: () => void;
  readonly isLoading: boolean;
}

export function CompetitorProductFilters({
  searchQuery,
  onSearchQueryChange,
  matchType,
  onMatchTypeChange,
  alertFilter,
  onAlertFilterChange,
  onSearch,
  onClear,
  isLoading,
}: CompetitorProductFiltersProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearch();
    }
  };

  return (
    <div className="py-2" style={{ borderTop: '1px solid #444' }}>
      <Row className="g-2 align-items-end">
        <Col xs={6} md={2}>
          <Form.Label style={{ fontSize: '0.75rem', marginBottom: '0.25rem', color: '#aaa' }}>
            Match Status
          </Form.Label>
          <Form.Select
            size="sm"
            value={matchType}
            onChange={(e) => onMatchTypeChange(e.target.value as MatchTypeFilter)}
            style={{ backgroundColor: '#333', color: '#fff', border: '1px solid #555' }}
          >
            <option value="matched">Matched</option>
            <option value="machineUnmatched">Machine Unmatched</option>
            <option value="humanUnmatched">Human Unmatched</option>
          </Form.Select>
        </Col>
        <Col xs={6} md={2}>
          <Form.Label style={{ fontSize: '0.75rem', marginBottom: '0.25rem', color: '#aaa' }}>
            Alert Filter
          </Form.Label>
          <Form.Select
            size="sm"
            value={alertFilter}
            onChange={(e) => onAlertFilterChange(e.target.value as AlertFilter)}
            style={{ backgroundColor: '#333', color: '#fff', border: '1px solid #555' }}
          >
            <option value="all">All</option>
            <option value="price_anomaly">Price Anomaly</option>
          </Form.Select>
        </Col>
        <Col xs={12} md={5}>
          <Form.Label style={{ fontSize: '0.75rem', marginBottom: '0.25rem', color: '#aaa' }}>
            Search (SKU, Brand, Name)
          </Form.Label>
          <Form.Control
            size="sm"
            type="text"
            placeholder="Search by SKU, brand, or name..."
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{ backgroundColor: '#333', color: '#fff', border: '1px solid #555' }}
            disabled={matchType !== 'matched'}
          />
        </Col>
        <Col xs={12} md={3} className="d-flex gap-2 justify-content-end">
          {searchQuery && (
            <Button variant="outline-secondary" size="sm" onClick={onClear} disabled={isLoading}>
              <X size={14} />
            </Button>
          )}
          <Button variant="primary" size="sm" onClick={onSearch} disabled={isLoading}>
            <Search size={14} className="me-1" />
            {isLoading ? '...' : searchQuery ? 'Search' : 'List All'}
          </Button>
        </Col>
      </Row>
    </div>
  );
}
